import UseProps from './useProps'

export default UseProps
